/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Weight_Settings_Card_DescInputs */

const vi_smartlab_weight_settings_card_desc = /** @type {(inputs: Smartlab_Weight_Settings_Card_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản đọc dữ liệu cân chè tươi từ hệ thống CanChe của SmartLab. Mỗi 2 giờ sáng hệ thống tự kéo dữ liệu về tạo phiếu cân.`)
};

/**

* @param {Smartlab_Weight_Settings_Card_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_weight_settings_card_desc = /** @type {((inputs?: Smartlab_Weight_Settings_Card_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Weight_Settings_Card_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_weight_settings_card_desc(inputs)
});